var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CesiumIonAsset } from "./CesiumIonAsset";
import { FileLoader } from "../../loaders";
import { QuantizedMeshTerrainProvider } from "../../terrain/QuantizedMeshTerrainProvider";
/**
 * A CesiumIonAsset specialization for handling Terrain assets
 */
export class CesiumIonTerrainAsset extends CesiumIonAsset {
    constructor(url, token, attributions, layer) {
        super(url, token, attributions);
        this._layer = layer;
    }
    /**
     *
     * @param endpoint
     */
    static fromEndpoint(endpoint) {
        return __awaiter(this, void 0, void 0, function* () {
            // While apparently the REST docs allow these to be undefined, we require all 3 fields to be present. If they
            // aren't then we return undefined as we can't produce an asset otherwise
            if (typeof endpoint.type === "undefined" ||
                typeof endpoint.url === "undefined" ||
                typeof endpoint.accessToken === "undefined") {
                throw new Error("CesiumIonAssetEndpoint does not have enough data to load an asset from");
            }
            const layer = yield FileLoader.loadJson(`${endpoint.url}layer.json`, {
                headers: {
                    Authorization: `Bearer ${endpoint.accessToken}`,
                },
            });
            if (!isQuantizedMeshTerrainLayer(layer)) {
                throw new Error("Received invalid 'layer.json' for quantized-mesh terrain");
            }
            // Strip empty strings
            if (layer.attribution === "")
                delete layer.attribution;
            if (layer.description === "")
                delete layer.description;
            if (layer.name === "")
                delete layer.name;
            return new CesiumIonTerrainAsset(endpoint.url, endpoint.accessToken, endpoint.attributions, layer);
        });
    }
    /**
     * Constructs a new {@link QuantizedMeshTerrainProvider} from this asset.
     */
    createTerrainProvider() {
        return new QuantizedMeshTerrainProvider(this.url, this._layer, {
            attributions: this.attributions,
            bearerToken: this.token,
        });
    }
}
/**
 * Checks if object 'v' matches the `QuantizedMeshAvailableRegion` interface
 * @param v
 */
export function isQuantizedMeshAvailableRegion(v) {
    if (typeof v !== "object")
        return false;
    if (typeof v.startX !== "number")
        return false;
    if (typeof v.startY !== "number")
        return false;
    if (typeof v.endX !== "number")
        return false;
    if (typeof v.endY !== "number")
        return false;
    return true;
}
export function isQuantizedMeshTerrainLayer(v) {
    if (typeof v !== "object")
        return false;
    if (typeof v.bounds === "undefined")
        return false;
    if (!Array.isArray(v.bounds) || v.bounds.length !== 4)
        return false;
    if (v.bounds.filter((i) => typeof i === "number").length !== v.bounds.length)
        return false;
    if (typeof v.tiles === "undefined")
        return false;
    if (!Array.isArray(v.tiles))
        return false;
    if (v.tiles.filter((i) => typeof i === "string").length !== v.tiles.length)
        return false;
    if (typeof v.available !== "undefined" && !Array.isArray(v.available))
        return false;
    {
        for (const i of v.available) {
            if (!Array.isArray(i))
                return false;
            for (const j of i) {
                if (!isQuantizedMeshAvailableRegion(j))
                    return false;
            }
        }
    }
    if (typeof v.extensions === "undefined")
        return false;
    if (!Array.isArray(v.extensions))
        return false;
    if (v.extensions.filter((i) => typeof i === "string").length !== v.extensions.length)
        return false;
    if (typeof v.format !== "string")
        return false;
    if (typeof v.minzoom !== "number")
        return false;
    if (typeof v.maxzoom !== "number")
        return false;
    if (typeof v.projection !== "string")
        return false;
    if (v.projection !== "EPSG:4326" && v.projection !== "EPSG:3857")
        return false;
    if (typeof v.scheme !== "string")
        return false;
    if (v.scheme !== "tms" && v.scheme !== "slippyMap")
        return false;
    if (typeof v.version !== "string")
        return false;
    if (typeof v.attribution !== "undefined" && typeof v.attribution !== "string")
        return false;
    if (typeof v.bvhlevels !== "undefined" && typeof v.bvhlevels !== "number")
        return false;
    if (typeof v.description !== "undefined" && typeof v.description !== "string")
        return false;
    if (typeof v.metadataAvailability !== "undefined" && typeof v.metadataAvailability !== "number")
        return false;
    if (typeof v.name !== "undefined" && typeof v.name !== "string")
        return false;
    return true;
}
